module.exports = ".display-conditions-info {\n  margin-bottom: 0;\n  padding: 10px; }\n  .display-conditions-info .fa-sitemap {\n    font-size: 16px; }\n  .display-conditions-info .label {\n    white-space: normal; }\n  .display-conditions-info .dependecies-list {\n    display: table;\n    width: 100%; }\n  .display-conditions-info .dependecies-entry {\n    margin-bottom: 3px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/sessions/registration-form/display-conditions/display-conditions.component.scss
// module id = ./src/app/modules/sessions/registration-form/display-conditions/display-conditions.component.scss
// module chunks = main